import { default as Assignment } from '@mui/icons-material/Assignment';
import CancelIcon from '@mui/icons-material/Cancel';
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogTitle,
    FormControlLabel,
    Radio,
    RadioGroup,
    Tooltip,
    Typography
} from '@mui/material';
import AUTO_TEXTO_CERTIDAO from '@/components/certidao/AutoTextoCertidao';
import Certidao from '@/components/certidao/Certidao';
import { MEIO_JULGAMENTO_PROCESSO } from '@/dominio/MeioJulgamentoProcesso';
import { MODO_PARTICIPACAO_ADVOGADO } from '@/dominio/ModoParticipacaoAdvogado';
import SituacaoJulgamentoProcessoBusiness from '@/dominio/SituacaoJulgamentoProcessoBusiness';
import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import Configuracao from '../../util/Configuracao';
import ErrorUtil from '../../util/ErrorUtil';
import Signatario from '../certidao/Signatario';
import NumeroProcesso from '../NumeroProcesso';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import CodDecisaoMovCNJ from './CodDecisaoMovCNJ';
import FiltroRapido from './FiltroRapido';
import ModalComposicao from './ModalComposicao';
import OperacoesEmLoteSelecionar from './OperacoesEmLoteSelecionar';
import PainelProcessosOperacoesEmLote from './PainelProcessosOperacoesEmLote';
import ProcuradorCertidao from './ProcuradorCertidao';

class ControleAtualizacoesCampos {
    constructor(textosAtuais, textosAlterados) {
        if (!textosAtuais) {
            textosAtuais = { rascunhoCertidao: '', decisaoCertidao: '' };
        }

        if (!textosAlterados) {
            textosAlterados = { rascunhoCertidao: '', decisaoCertidao: '' };
        }

        this.textosAtuais = textosAtuais;
        this.textosAlterados = textosAlterados;
    }
}

class GerarCertidaoEmLote extends ReactComponent {
    modalMovimentoDecisaoOpen = false;
    modalComposicaoOpen = false;
    modalProcuradorOpen = false;
    dialogOpen = false;
    cpfSignatario = null;
    certidaoSemModelo = false;
    certidaoPadrao = false;
    registroModal;
    restaurarCertidoes = false;
    restaurarCampoDecisaoCertidao = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            modalMovimentoDecisaoOpen: observable,
            modalComposicaoOpen: observable,
            modalProcuradorOpen: observable,
            dialogOpen: observable,
            cpfSignatario: observable,
            certidaoSemModelo: observable,
            certidaoPadrao: observable,
            registroModal: observable,
            restaurarCertidoes: observable,
            restaurarCampoDecisaoCertidao: observable,
            init: action,
            sessoes: computed,
            handleClickIcone: action,
            handleCloseDialog: action,
            processos: computed,
            processosComCertidaoGerada: computed,
            limparProcessoPesquisa: action,
            handleClickGerarCertidoes: action,
            prepararAutotextos: action,
            adicionarAutoTextoParticipacaoVirtual: action,
            callbackAlterarCpfSignatario: action,
            handleChangeCertidao: action,
            handleChangeRestaurarCertidoes: action,
            mensagemLoteSemProcessos: computed,
            handleClickWarningCertidao: action,
            handleCloseModalComposicao: action,
            handleCloseModalProcurador: action,
            callbackAlterarProcurador: action,
            handleCloseModalMovimentoDecisao: action,
            renderTituloDialog: computed,
            renderModalMovimentoDecisao: computed,
            renderConteudoDialog: computed
        });

        this.createReaction(
            reaction(
                () => this.dialogOpen,
                () => this.limparProcessoPesquisa()
            )
        );
    }

    componentDidMount() {
        this.init();
    }

    init() {
        if (this.sessao) {
            if (this.sessao.orgaoJudicante) {
                this.cpfSignatario = this.dominioStore.temSignatariosCadastradosOjc(this.sessao.orgaoJudicante.sigla)
                    ? this.dominioStore.signatarioCadastradoDefaultOjc(this.sessao.orgaoJudicante.sigla).cpf
                    : this.usuarioStore.usuario.cpf;
            } else {
                this.cpfSignatario = this.usuarioStore.usuario.cpf;
            }
        }
    }

    get sessoes() {
        return this.sessaoStore.sessaoSelecionada ? this.sessaoStore.sessaoSelecionada.sessoes : [];
    }

    handleClickIcone = () => {
        this.dialogOpen = true;
    };

    handleCloseDialog = () => {
        this.restaurarCertidoes = false;
        this.dialogOpen = false;
    };

    get processos() {
        let retorno = this.salaSessaoStore.processosApreciadosFiltrados || [];
        retorno = retorno.filter((registro) => !registro.certidaoGerada && this.filtrarProcessoPeloNumero(registro));
        return retorno;
    }

    get processosComCertidaoGerada() {
        let retorno = this.salaSessaoStore.processosApreciadosFiltrados || [];
        retorno = retorno.filter(
            (registro) =>
                registro.certidaoGerada &&
                !registro.certidaoJulgamentoAssinada &&
                this.filtrarProcessoPeloNumero(registro)
        );
        return retorno;
    }

    limparProcessoPesquisa = () => {
        this.processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
    };

    get processosSelecionaveis() {
        return this.processos.filter(
            (registro) =>
                !this.existeAlertaImpeditivoCertidao(registro) ||
                (!this.isVotoLiberado(registro) && !this.isProcessoApreciado(registro))
        );
    }

    handleClickGerarCertidoes = async () => {
        let processosSelecionados = this.processosSelecionaveis.filter((registro) =>
            this.store.isCheckedOperacoesEmLote(registro)
        );
        if (this.restaurarCertidoes) {
            processosSelecionados = processosSelecionados.concat(this.processosComCertidaoGerada);
        }
        if (processosSelecionados.length > 0) {
            await this.salaSessaoStore.processarLote({
                titulo: this.restaurarCertidoes ? 'Restaurando e gerando certidões' : 'Gerando certidões',
                qtdTotalProcessos: processosSelecionados.length,
                lotesProcessos: processosSelecionados,
                funcaoOperacao: (registro) => this.gerarCertidaoPadrao(registro)
            });
        } else {
            this.mensagemStore.abrirMensagemAlerta('Selecione um ou mais processos');
        }
    };

    async gerarCertidaoPadrao(registro) {
        let resultadoProcessamento;

        try {
            if (!registro) {
                throw new Error('Falha ao processar o registro.');
            }

            if (registro.necessitaImportacaoSalaSessao === true) {
                throw new Error('Processo não importado.');
            }

            if (registro.certidaoJulgamentoAssinada) {
                throw new Error('Não é possível restaurar, em lote, certidões já assinadas. Tente o modo unitário.');
            }

            let certidaoJSON;
            if (registro.certidaoGerada) {
                certidaoJSON = await this.certidaoService.recuperarCamposCertidao(
                    registro,
                    this.sessao.orgaoJudicante.sigla,
                    this.sessao.orgaoJudicante.descricao,
                    this.sessao.tipoJulgamento
                );
            }

            if (certidaoJSON?.assinada === true) {
                throw new Error('Não é possível restaurar, em lote, certidões já assinadas. Tente o modo unitário.');
            }

            await this.carregarDetalhes(registro);
            await this.carregarRascunhoCertidao(registro);

            let decisaoCertidaoTmp = undefined;
            if (registro.certidaoGerada && certidaoJSON) {
                decisaoCertidaoTmp = certidaoJSON.decisao ? certidaoJSON.decisao : '';
            }

            let controleAtualizacoesCampos = new ControleAtualizacoesCampos();
            controleAtualizacoesCampos.textosAtuais.rascunhoCertidao = registro.rascunhoCertidao;
            controleAtualizacoesCampos.textosAtuais.decisaoCertidao = decisaoCertidaoTmp || '';

            let novoRascunhoTmp;
            if (registro.rascunhoCertidao === undefined || registro.rascunhoCertidao.trim().length === 0) {
                novoRascunhoTmp = await this.salaSessaoStore.prepararRascunho(registro, registro.rascunhoCertidao);
            }

            if (decisaoCertidaoTmp === undefined || decisaoCertidaoTmp.trim().length === 0) {
                decisaoCertidaoTmp = novoRascunhoTmp || registro.rascunhoCertidao;
            }

            controleAtualizacoesCampos.textosAlterados.rascunhoCertidao = novoRascunhoTmp || registro.rascunhoCertidao;
            controleAtualizacoesCampos.textosAlterados.decisaoCertidao = decisaoCertidaoTmp;

            this.prepararAutotextos(registro, controleAtualizacoesCampos);
            const novoTextoRascunho = controleAtualizacoesCampos.textosAlterados.rascunhoCertidao;
            const novoTextoDecisaoCertidao = controleAtualizacoesCampos.textosAlterados.decisaoCertidao;

            if (novoTextoRascunho && novoTextoRascunho !== registro.rascunhoCertidao) {
                await this.certidaoService.salvarRascunhoCertidao(registro, novoTextoRascunho);
                runInAction(() => (registro.rascunhoCertidao = novoTextoRascunho));
            }

            resultadoProcessamento = await this.certidaoService.gerarCertidaoLote(
                this.sessao,
                registro,
                registro.certidaoGerada && !this.restaurarCampoDecisaoCertidao
                    ? novoTextoDecisaoCertidao
                    : novoTextoRascunho,
                this.cpfSignatario,
                this.certidaoSemModelo
            );

            if (resultadoProcessamento && !ErrorUtil.isResultadoErro(resultadoProcessamento)) {
                runInAction(() => {
                    registro.certidaoGerada = true;
                    registro.conteudoCertidao = resultadoProcessamento.conteudoCompleto;
                });
            }
        } catch (error) {
            resultadoProcessamento = ErrorUtil.getResultadoProcessamentoErro(error, registro.processo.numeroCompleto);
        }

        this.salaSessaoStore.incrementarProgressoLote();

        return resultadoProcessamento;
    }

    carregarProcuradorSessaoPJe(registro) {
        if (!registro.procurador && registro.processo.origem === Configuracao.ORIGEM_PJE) {
            runInAction(() => (registro.procurador = this.getProcuradorSessao(registro)));
        }
    }

    async carregarEmentaDecisao(registro) {
        if (!registro.decisao) {
            await this.salaSessaoStore.carregarEmentaDecisao(registro);
        }
    }

    async carregarRascunhoCertidao(registro) {
        if (!registro.rascunhoCertidao) {
            await this.salaSessaoStore.carregarRascunhoCertidao(registro);
        }
    }

    prepararAutotextos(registro, controleAtualizacoesCampos) {
        return this.adicionarAutoTextoParticipacaoVirtual(registro, controleAtualizacoesCampos);
    }

    adicionarAutoTextoParticipacaoVirtual(registro, controleAtualizacoesCampos) {
        const advsProcesso = Certidao.advogados(registro);
        const complemento = AUTO_TEXTO_CERTIDAO.REGISTRO_PARTICIPACAO_VIRTUAL.texto;

        advsProcesso.forEach((adv) => {
            if (adv.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo) {
                const obsParticipacaoVirtual = this.replaceHashTags(complemento, adv);
                this.adicionarObservacao(obsParticipacaoVirtual, controleAtualizacoesCampos);
            }
        });
    }

    adicionarObservacao(observacao, controleAtualizacoesCampos) {
        const atributos = ['rascunhoCertidao', 'decisaoCertidao'];

        for (const atributo of atributos) {
            let conteudoAtual = '';
            let novoConteudo = '';

            if (controleAtualizacoesCampos.textosAlterados[atributo]) {
                conteudoAtual = controleAtualizacoesCampos.textosAlterados[atributo];
            }

            if (conteudoAtual.indexOf(observacao) === -1) {
                novoConteudo = this.salaSessaoStore.renumerarObservacoes(conteudoAtual);
                let numeroObservacao = this.salaSessaoStore.getQuantidadeObservacoes(conteudoAtual) + 1;

                if (numeroObservacao === 1) {
                    novoConteudo += '\n';
                }

                novoConteudo += '\nObservação ' + numeroObservacao + ': ' + observacao + '.\n';
            } else {
                novoConteudo = conteudoAtual;
            }

            controleAtualizacoesCampos.textosAlterados[atributo] = novoConteudo;
        }
    }

    replaceHashTags(texto, advogado) {
        return texto
            .replace(/#ADV_GEN2/g, advogado.genero === 'F' ? 'a' : 'o')
            .replace(/#ADV_CAP_GEN2/g, advogado.genero === 'F' ? 'a' : 'o')
            .replace(/#ADV_GEN/g, advogado.genero === 'F' ? 'a' : '')
            .replace(/#NOME_ADV/g, advogado.nome ? advogado.nome.trim() : '')
            .replace(/#DENOMINACAO_PARTE/g, advogado.denominacaoDaParte)
            .replace(/#NOME_PARTE/g, advogado.nomeDaParte ? advogado.nomeDaParte.trim() : '');
    }

    advogadosParticipacaoVirtual(registro) {
        let advogados = [];

        if (registro?.pedidoSustentacaoOral?.pedidosDetalhados) {
            registro.pedidoSustentacaoOral.pedidosDetalhados.forEach((pedido) => {
                if (pedido?.advogados) {
                    pedido.advogados.forEach((adv) => {
                        if (
                            adv.modoParticipacao &&
                            adv.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo
                        ) {
                            advogados.push(adv);
                        }
                    });
                }
            });
        }

        let advogadosUnicos = this.salaSessaoStore.removerDuplicados(advogados, 'nome');

        advogadosUnicos = advogadosUnicos.slice().sort((adv1, adv2) => {
            return adv1.nome.localeCompare(adv2.nome);
        });

        return advogadosUnicos;
    }

    async carregarDetalhes(registro) {
        if (!registro.detalhes?.partesProcessuais) {
            await this.salaSessaoStore.carregarDetalhesProcesso(registro);
        }
    }

    getProcuradorSessao(registro) {
        return this.sessoes.find((sessao) => sessao.id === registro.sessaoId).procurador;
    }

    async callbackAlterarCpfSignatario(cpfSignatario) {
        this.cpfSignatario = cpfSignatario;
    }

    get sessao() {
        return this.sessaoStore.sessaoSelecionada;
    }

    handleChangeCertidao = () => {
        this.certidaoSemModelo = !this.certidaoSemModelo;
    };

    handleChangeRestaurarCertidoes = () => {
        this.restaurarCertidoes = !this.restaurarCertidoes;
    };

    get mensagemLoteSemProcessos() {
        return 'Não há processos apreciados sem certidão' + this.complementoMensagemFiltrando;
    }

    existeAlertaImpeditivoCertidao(registro) {
        return (
            !this.existePresidenteComposicao(registro) ||
            !this.validarProcuradorProcesso(registro) ||
            !this.existeMovimentoDecisao(registro) ||
            (!this.isVotoLiberado(registro) && this.isProcessoJulgado(registro))
        );
    }

    existeMovimentoDecisao(registro) {
        let retorno = false;
        if (registro) {
            retorno =
                registro.informacaoProcessoSalaSessao.decisao ||
                (registro.movimentos && registro.movimentos.length > 0);
        }
        return retorno;
    }

    existeRelatorComposicao(registro) {
        return !!(
            registro?.processo?.relator &&
            registro.composicao.findIndex((composicao) => composicao.magistrado.cpf === registro.processo.relator.cpf) >
                -1
        );
    }

    isVotoLiberado(registro) {
        return !!registro?.liberadoPeloRelator;
    }

    isProcessoApreciado(registro) {
        return SituacaoJulgamentoProcessoBusiness.isProcessoApreciado(registro?.resultadoJulgamento);
    }

    isProcessoJulgado(registro) {
        return SituacaoJulgamentoProcessoBusiness.isProcessoJulgado(registro?.resultadoJulgamento);
    }

    existePresidenteComposicao(registro) {
        return !!(
            registro?.composicao &&
            registro.composicao.findIndex((composicao) => composicao.magistrado.presidenteSessao === true) > -1
        );
    }

    validarProcuradorProcesso(registro) {
        return (
            registro?.tipoJulgamento === MEIO_JULGAMENTO_PROCESSO.VIRTUAL.codigo ||
            registro?.tipoJulgamento === MEIO_JULGAMENTO_PROCESSO.REMETIDO_PARA_SESSAO_VINCULADA.codigo ||
            registro?.procurador ||
            (registro?.processo?.origem === Configuracao.ORIGEM_PJE && this.procuradorSessao)
        );
    }

    procuradorSessao(registro) {
        return this.sessoes.find((sessao) => sessao.id === registro.sessaoId).procurador;
    }

    handleClickWarningCertidao = (registro) => {
        if (!this.existePresidenteComposicao(registro) || !this.existeRelatorComposicao(registro)) {
            this.registroModal = registro;
            this.modalComposicaoOpen = true;
        } else if (!this.validarProcuradorProcesso(registro)) {
            this.registroModal = registro;
            this.modalProcuradorOpen = true;
        } else if (!this.existeMovimentoDecisao(registro)) {
            this.registroModal = registro;
            this.modalMovimentoDecisaoOpen = true;
        }
    };

    handleCloseModalComposicao = () => {
        this.modalComposicaoOpen = false;
        this.registroModal = undefined;
    };

    handleCloseModalProcurador = () => {
        this.modalProcuradorOpen = false;
        this.registroModal = undefined;
    };

    callbackAlterarProcurador = async (procurador) => {
        this.registroModal.procurador = procurador;
        if (this.registroModal.processo.origem === Configuracao.ORIGEM_SIJ) {
            await this.sessaoService.alterarProcurador(
                this.registroModal.sessaoId,
                this.registroModal.processo.numeroCompleto,
                procurador
            );
        }
    };

    getAlertasProcesso = (registro) => {
        let alertas = [];

        if (!this.existeRelatorComposicao(registro)) {
            alertas.push({
                mensagem: 'Processo sem relator na composição',
                impeditivo: true,
                handleClick: this.handleClickWarningCertidao
            });
        }

        if (!this.existePresidenteComposicao(registro)) {
            alertas.push({
                mensagem: 'Processo sem presidente na composição',
                impeditivo: true,
                handleClick: this.handleClickWarningCertidao
            });
        }

        if (!this.validarProcuradorProcesso(registro)) {
            alertas.push({
                mensagem: 'Processo sem procurador',
                impeditivo: true,
                handleClick: this.handleClickWarningCertidao
            });
        }

        if (!this.existeMovimentoDecisao(registro)) {
            alertas.push({
                mensagem: `Processo sem ${this.getComplementoMensagemSemMovimentoDecisao(registro)}`,
                impeditivo: true,
                handleClick: this.handleClickWarningCertidao
            });
        }

        if (!this.isVotoLiberado(registro) && this.isProcessoJulgado(registro)) {
            alertas.push({
                mensagem: 'Processo julgado com voto não liberado pelo relator',
                impeditivo: true,
                handleClick: this.handleClickWarningCertidao
            });
        }

        if (alertas.length > 0) {
            alertas[0].mensagem = alertas[0].mensagem + '. Clique para alterar.';
        }

        return alertas;
    };

    getComplementoMensagemSemMovimentoDecisao(registro) {
        return registro.processo.origem === Configuracao.ORIGEM_PJE ? 'movimentos' : 'decisão';
    }

    handleCloseModalMovimentoDecisao = () => {
        this.modalMovimentoDecisaoOpen = false;
    };

    render() {
        if (!this.isComponenteHabilitado('GerarCertidaoEmLote') || !this.parametroStore.usaCertidao()) {
            return null;
        }

        return (
            <div>
                <div
                    style={{ marginRight: '12px', cursor: 'pointer' }}
                    className="corBotao"
                >
                    <Tooltip
                        title={'Gerar certidões em lote'}
                        placement="top-start"
                    >
                        <Assignment onClick={this.handleClickIcone} />
                    </Tooltip>
                </div>
                {this.dialogOpen && (
                    <Dialog
                        fullWidth
                        maxWidth="xl"
                        onClose={this.handleCloseDialog}
                        open={this.dialogOpen}
                        slotProps={{
                            paper: {
                                sx: {
                                    height: '100%'
                                }
                            }
                        }}
                    >
                        {this.renderTituloDialog}
                        {this.renderConteudoDialog}
                        <DialogActions>
                            <Button
                                onClick={this.handleCloseDialog}
                                color="secondary"
                                variant="outlined"
                                endIcon={<CancelIcon />}
                            >
                                Fechar
                            </Button>
                            <Button
                                onClick={this.handleClickGerarCertidoes}
                                color="primary"
                                variant="contained"
                                endIcon={<Assignment />}
                            >
                                Gerar
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
                {this.modalComposicaoOpen && (
                    <ModalComposicao
                        open={true}
                        registro={this.registroModal}
                        onClose={this.handleCloseModalComposicao}
                        onCancel={this.handleCloseModalComposicao}
                    />
                )}
                {this.modalProcuradorOpen && (
                    <ProcuradorCertidao
                        ocultarIcone
                        open
                        registro={this.registroModal}
                        handleClose={this.handleCloseModalProcurador}
                        callbackAlterarProcurador={this.callbackAlterarProcurador}
                    />
                )}
                {this.renderModalMovimentoDecisao}
            </div>
        );
    }

    get renderTituloDialog() {
        return (
            <DialogTitle
                id="simple-dialog-title"
                style={{ padding: '16px 24px 0px' }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <h4 style={{ margin: '0px' }}>Gerar certidões em lote</h4>
                    </div>
                    <div style={{ margin: '0px 10px' }}>
                        <NumeroProcesso
                            dense
                            tooltip="Número do processo a ser pesquisado na listagem"
                            callbackOnChange={this.callbackNumeroProcesso}
                            clickLimpar={this.limparProcessoPesquisa}
                        />
                    </div>
                    <div style={{ flexGrow: 1, marginRight: '16px' }}>
                        <Signatario
                            cpfSignatario={this.cpfSignatario}
                            callbackAlterarCpfSignatario={this.callbackAlterarCpfSignatario.bind(this)}
                        />
                    </div>
                    <div>
                        <span style={{ marginLeft: '10px' }}>Modelo:</span>
                        <RadioGroup
                            row
                            value={this.certidaoSemModelo}
                            onChange={this.handleChangeCertidao}
                            style={{ marginLeft: '10px' }}
                        >
                            <FormControlLabel
                                label="Padrão"
                                value={false}
                                control={<Radio />}
                            />
                            <FormControlLabel
                                label="Em branco"
                                value={true}
                                control={<Radio />}
                            />
                        </RadioGroup>
                        {this.processosComCertidaoGerada.length > 0 && (
                            <Typography
                                variant="subtitle1"
                                color="primary"
                                style={{ paddingRight: '15px', whiteSpace: 'nowrap', textAlign: 'center' }}
                            >
                                <Checkbox
                                    checked={this.restaurarCertidoes}
                                    onChange={this.handleChangeRestaurarCertidoes}
                                />
                                <b>Restaurar {this.processosComCertidaoGerada.length} certidão(ões) já criada(s)</b>
                            </Typography>
                        )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', margin: '10px', paddingTop: '5px' }}>
                            <PainelFiltros />
                        </div>
                        <FiltroRapido id="filtroRapidoCertidaoEmLote" />
                    </div>
                </div>
            </DialogTitle>
        );
    }

    get renderModalMovimentoDecisao() {
        if (!this.modalMovimentoDecisaoOpen) {
            return null;
        }

        return (
            <Dialog
                open
                fullWidth
                maxWidth="md"
                onClose={this.handleCloseModalMovimentoDecisao}
                slotProps={{
                    paper: {
                        sx: {
                            padding: '20px 20px 0px'
                        }
                    }
                }}
            >
                <CodDecisaoMovCNJ
                    registro={this.registroModal}
                    id="certidaoLote"
                />
                <DialogActions>
                    <Button
                        onClick={this.handleCloseModalMovimentoDecisao}
                        color="secondary"
                        variant="outlined"
                        endIcon={<CancelIcon />}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    get renderConteudoDialog() {
        return (
            <Fragment>
                <OperacoesEmLoteSelecionar
                    processosSelecionaveis={this.processosSelecionaveis}
                    processos={this.processos}
                />
                <PainelProcessosOperacoesEmLote
                    processos={this.processos}
                    mensagemLoteSemProcessos={this.mensagemLoteSemProcessos}
                    alertasProcessos={this.alertasProcessos}
                />
            </Fragment>
        );
    }
}

export default inject('stores')(observer(GerarCertidaoEmLote));
